import { get } from "./api";

export const getVendorsAnalysis = (id, formattedDate, params, signal) => {
  const url = `/api/v2/customers/${id}/vendoranalysis/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getAccountListing = (id, signal) => {
  const url = `/api/v2/customers/${id}/accountlisting/`;
  return get(url, {}, false, signal, true);
};

export const getTransactions = (id, date, vendor, account, signal) => {
  const url = `/api/v2/customers/${id}/vendortransactions/${date}/${vendor}/${account}`;
  return get(url, {}, false, signal, true);
};

export const getVendorsAnalysisExport = (id, formattedDate, params, signal) => {
  const url = `/api/v2/customers/${id}/exportvendoranalysis/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getTransactionsExport = (id, date, vendor, accountId, params, signal) => {
  const url = `/api/v2/customers/${id}/exporttransactionanalysis/${date}/${vendor}/${accountId}/`;
  return get(url, params, false, signal, true);
};
